export const USERTYPES = {
    ACCOUNTANT: 'ACCOUNTANT',
    CONVEYANCER: 'CONVEYANCER',
    MORTGAGE_BROKER: 'MORTGAGE BROKER',
    FINANCIAL_PLANER: 'FINANCIAL PLANER',
    OTHER: 'OTHER'
};
